import { useEffect } from "react";

export function useFocusBoundaryFix(active: boolean) {
  useEffect(() => {
    if (!active) return;

    function ensureFocusSinks() {
      if (document.getElementById("focus-sink-top")) return;

      const createSink = (id: string) => {
        const el = document.createElement("div");
        el.id = id;
        el.tabIndex = -1;
        el.setAttribute("aria-hidden", "true");

        Object.assign(el.style, {
          position: "fixed",
          width: "1px",
          height: "1px",
          opacity: "0",
          pointerEvents: "none",
          zIndex: "-1",
        });

        return el;
      };

      document.body.appendChild(createSink("focus-sink-bottom"));
    }

    function nativeBlur() {
      const active = document.activeElement as HTMLElement | null;
      console.debug("nativeBlur", active);
      if (active && active !== document.body) {
        console.debug("last active before blur", active);
        active.blur();
      }

      // Always redirect focus to a safe sink
      document.getElementById("focus-sink-bottom")?.focus();
    }

    (window as any).__nativeBlur = nativeBlur;

    ensureFocusSinks();

    return () => {
      delete (window as any).__nativeBlur;
      document.getElementById("focus-sink-bottom")?.remove();
    };
  }, [active]);
}
